import { Component, Input, Output } from 'angular-ts-decorators';

import { SwChange } from '@core/app/scripts/classes/sw-change';

import { faCheck, faMinus } from '@fortawesome/pro-solid-svg-icons';

/**
 * A component to select a single boolean value like a checkbox.
 * Inherits from {@link coreModule.SwChange SwChange} so will try to notify {@link
 * coreModule.directive:swChangeWrapper}.
 *
 * # HTML Example - SwChange
 * <code><pre>
 * <sw-select model="$ctrl.model" options="$ctrl.options" sw-change="$ctrl.set(value)"></sw-select>
 * </pre></code>
 *
 * where
 * * model is the boolean value
 * * options is an object with trueOption and falseOption values
 * * swChange is a callback that is called with newly set value everytime when
 * it'is changed
 *
 * # HTML Example - older
 * <code><pre>
 * <sw-select model="$ctrl.model" options="$ctrl.options" on-change="$ctrl.onChange()"></sw-select>
 * </pre></code>
 *
 * where
 * * onChange is a callback that is called everytime when value is changed
 */
@Component({
  selector: 'swSelect',
  template: require('./sw-select.html').default,
  transclude: true,
})
export class SwSelectComponent extends SwChange {
  @Input() options;
  @Output() onChange: () => any;
  @Output('=') model: boolean;

  faMinus = faMinus;
  faCheck = faCheck;
  trueOption: boolean;
  falseOption: boolean;
  localValue: boolean;

  constructor(private $timeout: ng.ITimeoutService) {
    'ngInject';
    super();

    this.trueOption = true;
    this.falseOption = false;
    this.localValue = false;
  }

  $onInit() {
    if (angular.isObject(this.options)) {
      this.trueOption = this.options.trueOption
        ? this.options.trueOption
        : true;
      this.falseOption = this.options.falseOption
        ? this.options.falseOption
        : false;
    }

    this.localValue = this.model === this.trueOption;
  }

  modelChange() {
    this.model = this.localValue === true ? this.trueOption : this.falseOption;

    // Workaround to let the model propagate. It force model value in the
    // parent to be updated, before callbacks are run. Most likely it doest
    // happen immediately, because of some performance optimization in angular.
    this.$timeout(() => {
      this.change(this.model);

      if (angular.isFunction(this.onChange)) {
        this.onChange();
      }
    }, 0);
  }
}
